export function changeTopToPrefPageHash() {
  const targetEls = document.querySelectorAll("[data-change-pref-page-hash]")

  if (!targetEls.length) return

  targetEls.forEach((el: HTMLAnchorElement) => {
    el.addEventListener("click", (e) => {
      e.preventDefault()
      const currentHref = el.href;
      const value = el.getAttribute("data-change-pref-page-hash");
      if (value) {
        const url = new URL(currentHref);
        url.search = value;
        location.href = url.toString();
      }
    })
  })
}
